<template>
  <div>
    <Header v-if="this.$store.getters.isOturum"></Header>
    <router-view></router-view>
  </div>
</template>
<script>
import Header from './components/Doc/Header'

export default {
  components: {
    Header
  },
  data() {
    return {
      lo: false,
      Logo: null
    }
  },
  beforeCreate() {
  },
  created() {
    this.$store.dispatch("initAuth");
    // window.addEventListener('contextmenu', event => {
    //   console.log(event);
    //   event.returnValue = false;
    // });

    window.addEventListener('keyup', event => {
      if (event.key === "F1") router.push("/panel");
      if (event.key === "F2") router.push("/bina");
      if (event.key === "F3") router.push("/donem");
      if (event.key === "F4") router.push("/dokum");
      if (event.key === "F5") router.push("/abone");
    });

  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue